"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
const config_1 = require("./generated/config");
Object.defineProperty(exports, "config", { enumerable: true, get: function () { return config_1.config; } });
/**
 * The following line makes sure the format of the source json file matches
 * the types. It's a validation step. Keep it.
 */
config_1.config;
